export default __webpack_public_path__ + "static/media/email.34665a9a.svg";